import React from 'react';
import PropTypes from 'prop-types';
import EventPageContent from '../../components/EventPageContent';
import { keysToCamelFromSnake } from '../../utils/caseconverters';
import { basePageWrap } from '../BasePage';
import s from './EventPage.module.scss';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';

const EventPage = (props) => {
  const camelProps = keysToCamelFromSnake(props);
  const { related, event } = camelProps;
  const { breadcrumbs } = props;

  const formattedEvent = event
    ? {
        ...event,
        startDate: new Date(event.startDate),
        endDate: new Date(event.endDate),
      }
    : null;

  return (
    <div className={s.Root}>
      {breadcrumbs && <Breadcrumb {...breadcrumbs} />}
      {formattedEvent && (
        <EventPageContent {...formattedEvent} related={related} />
      )}
    </div>
  );
};

EventPage.propTypes = {
  contentBlocks: PropTypes.array,
};

export default basePageWrap(EventPage);
